// extracted by mini-css-extract-plugin
export var LightBox = "LightBox-module--LightBox--oAZBR";
export var LightBoxAnim20180710 = "LightBox-module--LightBoxAnim20180710--plyQd";
export var background = "LightBox-module--background--OVk3u";
export var close = "LightBox-module--close--RQ0WD";
export var imageContainer = "LightBox-module--imageContainer--jPRcp";